"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cell = void 0;
const DateTime_1 = require("./DateTime");
const Link_1 = require("./Link");
exports.Cell = {
    DateTime: DateTime_1.DateTimeCell,
    Link: Link_1.LinkCell,
};
